import { PropsWithChildren } from 'react'
import cx from 'classnames'
import Styles from './TextTab.module.scss'

const Root = ({ children }: PropsWithChildren<{}>) => <div className={Styles.section}>{children}</div>

const Header = ({ children, sticky = false }: PropsWithChildren<{ sticky?: boolean }>) => (
  <div className={cx(Styles.sectionHeader, { [Styles.sticky]: sticky })}>{children}</div>
)

export const Section = {
  Root,
  Header,
}
